import { SVGProps } from 'react'

export const RemoveShoppingCartIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_4008_81229)">
        <path d="M1.97641 0.564941L0.566406 1.97494L4.95641 6.36494L7.16641 11.0249L5.81641 13.4749C5.65641 13.7549 5.56641 14.0849 5.56641 14.4349C5.56641 15.5349 6.46641 16.4349 7.56641 16.4349H15.0264L16.4064 17.8149C15.9064 18.1749 15.5764 18.7649 15.5764 19.4349C15.5764 20.5349 16.4664 21.4349 17.5664 21.4349C18.2364 21.4349 18.8264 21.1049 19.1864 20.5949L22.0264 23.4349L23.4364 22.0249L1.97641 0.564941ZM7.56641 14.4349L8.66641 12.4349H11.0264L13.0264 14.4349H7.56641ZM20.5664 3.43494H7.68641L9.68641 5.43494H18.8764L16.1164 10.4349H14.6764L16.6164 12.3749C17.1564 12.2349 17.6064 11.8849 17.8664 11.4049L21.4464 4.91494C21.8164 4.25494 21.3264 3.43494 20.5664 3.43494ZM7.56641 17.4349C6.46641 17.4349 5.57641 18.3349 5.57641 19.4349C5.57641 20.5349 6.46641 21.4349 7.56641 21.4349C8.66641 21.4349 9.56641 20.5349 9.56641 19.4349C9.56641 18.3349 8.66641 17.4349 7.56641 17.4349Z" />
      </g>
      <defs>
        <clipPath id="clip0_4008_81229">
          <rect width="24" height="24" />
        </clipPath>
      </defs>
    </svg>
  )
}
